import React, { useState, useEffect, useRef } from "react";
import { Modal, Box, Typography, TextField, Grid } from "@mui/material";
import MDButton from "components/MDButton";
import axios from "axios";
import { useAlerta } from "utils/alertas";
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

export default function InscripcionCarreraModal({
  open,
  handleClose,
  usuarioId,
  items,
  carreras
}) {
  const [form, setForm] = useState({
    carrera_id: "",
    grupo_id: "",
    semestre_id: "",
    matricula_costo: "",
    matricula_pagado: "",
    mensualidad_costo: "",
    mensualidad_pagado: "",
    metodo_pago: "",
  });

  const [grupos, setGrupos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tipoPrograma, setTipoPrograma] = useState("");
  const [tipo_inscripcion, setTipoInscripcion] = useState("");
  const [tipoCarrera, setTipoCarrera] = useState("");
  const [instituto, setInstituto] = useState(""); // infopro | cladecorp
  const [duracion, setDuracion] = useState("");
  const [capacitaciones, setCapacitaciones] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [pensumsDisponibles, setPensumsDisponibles] = useState([]);
  const { mostrarAlerta } = useAlerta();
  const [arrastres, setArrastres] = useState([]);
  const [mensajeArrastre, setMensajeArrastre] = useState("");
  const [loadingPensum, setLoadingPensum] = useState(false);
  const [semestre, setSemestre] = useState("");
  const [semestresDisponibles, setSemestresDisponibles] = useState([]);
  const [gestiones , setGestiones]=useState([]);
  const [materiasDisponibles, setMateriasDisponibles] = useState([]);
  const [materiasSeleccionadas, setMateriasSeleccionadas] = useState([]);
  const gruposCache = useRef({});
  const token = sessionStorage.getItem("access_token");

  useEffect(() => {
    if (tipoPrograma === "capacitacion" && semestresDisponibles.length > 0) {
      const primero = semestresDisponibles[0];

      setSemestre(primero.id);

      setForm(prev => ({
        ...prev,
        semestre_id: primero.id
      }));
    }
  }, [tipoPrograma, semestresDisponibles]);

  const fetchSemestres = async (tipo, id) => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/semestre/${tipo}/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
          }
        );

        const data = await res.json();

        const lista = Array.isArray(data.data) ? data.data : data;

        setSemestresDisponibles(lista || []);

      } catch (error) {
        console.error(error);
        setSemestresDisponibles([]);
      }
    };
    const fetchGestiones = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/gestiones`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });

        const data = await res.json();
        setGestiones(Array.isArray(data) ? data : data.data || []);

      } catch (error) {
        console.error(error);
        setGestiones([]);
      }
    };
    useEffect(() => {
      fetchGestiones();
    }, []);
    const fetchMaterias = async (semestreId) => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_API_URL}/semestres/${semestreId}/materias`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      }
    );

    const data = await res.json();
    let materias = Array.isArray(data.data) ? data.data : data;

    // 🔥 1. Crear mapa con materias del semestre
    const mapa = new Map();

    materias.forEach(m => {
      mapa.set(m.id, {
        ...m,
        esArrastre: false
      });
    });

    // 🔥 2. Agregar arrastres (aunque NO estén en el semestre)
    arrastres.forEach(a => {
      mapa.set(a.id, {
        ...a,
        esArrastre: true
      });
    });

    // 🔥 3. Convertir a array final
    const resultado = Array.from(mapa.values());

    setMateriasDisponibles(resultado);

  } catch (error) {
    console.error(error);
    setMateriasDisponibles([]);
  }
};
    useEffect(() => {
  if (semestre) {
    fetchMaterias(semestre);
  }
}, [semestre, arrastres]); // 🔥 clave
  

  // 🔹 Limpiar formulario al cerrar modal
  useEffect(() => {
  if (open) {
    setForm({
      carrera_id: "",
      grupo_id: "",
      semestre_id: "",
      matricula_costo: "",
      matricula_pagado: "",
      mensualidad_costo: "",
      mensualidad_pagado: "",
      metodo_pago: "",
      numero_cuotas: "",
    });

    setTipoPrograma("");
    setTipoInscripcion("");
    setTipoCarrera("");
    setInstituto("");
    setDuracion("");

    setGrupos([]);
    setCapacitaciones([]);
    setPensumsDisponibles([]);
    setSemestresDisponibles([]);
    setMateriasDisponibles([]);
    setMateriasSeleccionadas([]);
    setSelectedItems([]);

    setArrastres([]);
    setMensajeArrastre("");

    setSemestre("");
  }
}, [open]);
useEffect(() => {
  if (!open || !usuarioId) return;

  axios.get(`${process.env.REACT_APP_API_URL}/arrastres/materias-debe/${usuarioId}`)
    .then(res => {
      const data = res.data;

      if (data.tieneDeudas || data.materias_en_curso?.length > 0) {
        setArrastres(data.materias);

        setMensajeArrastre(
          data.mensaje || "El estudiante presenta observaciones académicas."
        );
      } else {
        setArrastres([]);
        setMensajeArrastre("No tiene materias pendientes ✅");
      }
    })
    .catch(() => {
      setMensajeArrastre("Error al verificar arrastres");
    });

}, [open, usuarioId]);
  const calcularTotalPagado = () => {
  return (
    Number(form.matricula_pagado || 0) +
    Number(form.mensualidad_pagado || 0) +
    selectedItems.reduce(
      (acc, i) => acc + Number(i.pagado || 0),
      0
    )
  );
};

  useEffect(() => {
    if (tipoPrograma !== "capacitacion") return;

    axios.get(`${process.env.REACT_APP_API_URL}/modulos`)
      .then(res => {
  const data = res.data;

  // 🔥 Asegurar que siempre sea array
  if (Array.isArray(data)) {
    setCapacitaciones(data);        
  } else if (Array.isArray(data.data)) {
    setCapacitaciones(data.data);
  } else {
    setCapacitaciones([]);
  }
})
      .catch(() => setCapacitaciones([]));

  }, [tipoPrograma]);
  useEffect(() => {
  if (!form.gestion || !form.semestre_id) {
    setGrupos([]);
    return;
  }

  const key = `grupos-${form.gestion}-${form.semestre_id}`;

  // cache
  if (gruposCache.current[key]) {
    setGrupos(gruposCache.current[key]);
    return;
  }

  axios.get(
    `${process.env.REACT_APP_API_URL}/grupos/${form.gestion}/${form.semestre_id}/semestres`
  )
    .then(res => {
      const data = res.data.data || res.data;

      gruposCache.current[key] = data;
      setGrupos(data);
    })
    .catch((error) => {
      console.error("Error al cargar grupos:", error);
      setGrupos([]);
    });

}, [form.gestion, form.semestre_id]); // Solo se dispara cuando cambia el pensum_id




  const handleChange = (e) => {
  const { name, value } = e.target;

  // 1. Actualizamos el estado normal del formulario
  setForm((prev) => ({
    ...prev,
    [name]: value,
  }));

  // 2. Lógica para buscar Pensum según el campo que cambie
  if (name === "carrera_id" && value) {
    // Si cambió la carrera
    fetchSemestres("carrera", value);
  } 
  else if (name === "capacitacion_id" && value) {
    // Si cambió la capacitación
    fetchSemestres("capacitacion", value);
  }
};

  const handleSubmit = async () => {
    setLoading(true);
    try {

      const payload = {
        usuario_id: usuarioId,
        tipoPrograma,
        tipo_inscripcion,
        carrera_id: tipoPrograma === "carrera" ? form.carrera_id : null,
        capacitacion_id: tipoPrograma === "capacitacion" ? form.capacitacion_id : null,
        semestre_id: form.semestre_id,
        grupo_id: form.grupo_id,
        gestion_id: form.gestion,
        matricula_costo: form.matricula_costo,
        matricula_pagado: form.matricula_pagado,
        matricula_pago_qr: form.matricula_pago_qr,
        matricula_pago_efectivo: form.matricula_pago_efectivo,
        mensualidad_costo: form.mensualidad_costo,
        mensualidad_pagado: form.mensualidad_pagado,
        mensualidad_pago_qr: form.mensualidad_pago_qr,
        mensualidad_pago_efectivo: form.mensualidad_pago_efectivo,
        metodo_pago: form.metodo_pago,
        numero_cuotas: form.numero_cuotas,
        items: selectedItems,
        materias: materiasSeleccionadas,
      };
      console.log("📤 PAYLOAD QUE SE ENVÍA:");
      console.log(payload);

      await axios.post(`${process.env.REACT_APP_API_URL}/inscripcion-carrera`, payload);

      // 🔥 AQUÍ METES TU SNACKBAR
      mostrarAlerta("Inscripción exitosa");

      handleClose();

    } catch (error) {
      console.error("ERROR COMPLETO:", error);
      const mensaje =
        error.response?.data?.message || "Error al inscribir";
      mostrarAlerta(mensaje, "error");
    } finally {
      setLoading(false);
    }
  };
  const calcularDeuda = () => {
  const safeNumber = (val) => Number(val) || 0;

  // Matrícula
  const deudaMatricula =
    safeNumber(form.matricula_costo) -
    safeNumber(form.matricula_descuento) -
    safeNumber(form.matricula_pagado);

  // Mensualidad (SIN tomar en cuenta número de cuotas)
  const deudaMensualidad =
    safeNumber(form.mensualidad_costo) -
    safeNumber(form.mensualidad_descuento) -
    safeNumber(form.mensualidad_pagado);

  // Otros cobros
  const deudaOtros = selectedItems
    .filter((item) => {
      const concepto = (item.concepto || "")
        .trim()
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");

      return (
        concepto !== "matricula" &&  
        concepto !== "mensualidad"
      );
    })
    .reduce((acc, item) => {
      const monto = safeNumber(item.monto);
      const pagado = safeNumber(item.pagado);
      const descuento = safeNumber(item.descuento);

      return acc + (monto - descuento - pagado);
    }, 0);

  return Math.max(
    deudaMatricula +
      deudaMensualidad +
      deudaOtros,
    0
  );
};

  return (
    <Modal open={!!open} onClose={handleClose}>
      <Box sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        bgcolor: "background.paper",
        boxShadow: 24,
        borderRadius: 2,
        p: 3,
        width: { xs: "90%", sm: 600, md: 800 },
        maxHeight: "90vh",
        overflowY: "auto",
      }}>

        <Typography variant="h6" gutterBottom>
          Inscribir a Carrera
        </Typography>
        {mensajeArrastre && (
          <Box
            p={2}
            borderRadius={2}
            bgcolor={arrastres.length > 0 ? "#fff3cd" : "#d4edda"}
            color={arrastres.length > 0 ? "#856404" : "#155724"}
          >
            <Typography variant="body2" sx={{ whiteSpace: "pre-line" }}>
              {mensajeArrastre}
            </Typography>
          </Box>
        )}

        {/* ================== SECCIÓN 1: PROGRAMA ================== */}
        <Typography variant="subtitle1" fontWeight="bold" mt={2}>
          Programa
        </Typography>

        <TextField
          select
          fullWidth
          label="Tipo de programa"
          value={tipoPrograma}
          onChange={(e) => {
            setTipoPrograma(e.target.value);
            setForm({ ...form, carrera_id: "", capacitacion_id: "" });
            setGrupos([]);
          }}
          SelectProps={{ native: true }}
          sx={{ mt: 1 }}
        >
          <option value=""></option>
          <option value="carrera">Carrera</option>
          <option value="capacitacion">Capacitación</option>
        </TextField>
        <TextField
          select
          fullWidth
          label="Tipo de inscripcion"
          value={tipo_inscripcion}
          onChange={(e) => {
            setTipoInscripcion(e.target.value);
            setGrupos([]);
          }}
          SelectProps={{ native: true }}
          sx={{ mt: 1 }}
        >
          <option value=""></option>
          <option value="nueva">Nueva</option>
          <option value="reinscripcion">Reinscripcion</option>
        </TextField>

        {/* ===== CARRERA ===== */}
        {tipoPrograma === "carrera" && (
          <>
            <TextField
              select
              fullWidth
              label="Tipo de carrera"
              value={tipoCarrera}
              onChange={(e) => setTipoCarrera(e.target.value)}
              SelectProps={{ native: true }}
              sx={{ mt: 2 }}
            >
              <option value=""></option>
              <option value="anual">Anual</option>
              <option value="semestral">Semestral</option>
            </TextField>

            <TextField
              select
              fullWidth
              label="Carrera"
              name="carrera_id"
              value={form.carrera_id}
              onChange={handleChange}
              SelectProps={{ native: true }}
              sx={{ mt: 2 }}
            >
              <option value=""></option>
              {carreras
                .filter(c => c.tipo === tipoCarrera)
                .map(c => (
                  <option key={c.id} value={c.id}>{c.nombre}</option>
                ))}
            </TextField>
            <TextField
              select
              fullWidth
              label="Semestre/Año"
              value={form.semestre_id}
              sx={{ mt: 2 }}
              onChange={(e) => {
                const val = e.target.value;

                setSemestre(val);

                setForm(prev => ({
                  ...prev,
                  semestre_id: val
                }));
              }}
              SelectProps={{ native: true }}
              >
                <option value=""></option>
                {semestresDisponibles.map(s => (
                  <option key={s.id} value={s.id}>
                    {s.nombre} {s.numero}
                  </option>
                ))}
              </TextField>
              <Box mt={3}>
                <Typography variant="subtitle1" fontWeight="bold">
                  Materias a Inscribir
                </Typography>

                {materiasDisponibles.map((m) => (
                  <FormControlLabel
                    key={m.id}
                    control={
                      <Checkbox
                        checked={materiasSeleccionadas.some(ms => ms.id === m.id)}
                        onChange={(e) => {

                          if (e.target.checked) {
                            setMateriasSeleccionadas([
                              ...materiasSeleccionadas,
                              m
                            ]);
                          } else {
                            setMateriasSeleccionadas(
                              materiasSeleccionadas.filter(ms => ms.id !== m.id)
                            );
                          }
                        }}
                      />
                    }
                    label={
                      m.esArrastre
                        ? `⚠️ ${m.nombre} (Arrastre)`
                        : m.asignatura
                    }
                  />
                ))}
              </Box>
          </>
        )}

        {/* ===== CAPACITACIÓN ===== */}
        {tipoPrograma === "capacitacion" && (
          <>
            <TextField
              select
              fullWidth
              label="Instituto"
              value={instituto}
              onChange={(e) => setInstituto(e.target.value)}
              SelectProps={{ native: true }}
              sx={{ mt: 2 }}
            >
              <option value=""></option>
              <option value="INFOPRO">INFOPRO</option>
              <option value="CLADECORP">CLADECORP</option>
            </TextField>

            <TextField
              select
              fullWidth
              label="Duración"
              value={duracion}
              onChange={(e) => setDuracion(e.target.value)}
              SelectProps={{ native: true }}
              sx={{ mt: 2 }}
            >
              <option value=""></option>

              {instituto === "INFOPRO" && (
                <>
                  <option value="4 mes">4 mes</option>
                  <option value="7 mes">7 mes</option>
                </>
              )}

              {instituto === "CLADECORP" && (
                <>
                  <option value="1 mes">1 mes</option>
                  <option value="4 mes">4 mes</option>
                  <option value="7 mes">7 mes</option>
                </>
              )}
            </TextField>

            <TextField
              select
              fullWidth
              label="Capacitación"
              name="capacitacion_id"
              value={form.capacitacion_id || ""}
              onChange={handleChange}
              SelectProps={{ native: true }}
              sx={{ mt: 2 }}
            >
              <option value=""></option>
              {capacitaciones
              
                .filter(c =>
                  
                  c.instituto?.toLowerCase().trim() === instituto.toLowerCase().trim() &&
                  c.duracion?.toLowerCase().trim() === duracion.toLowerCase().trim()
                )
                .map(c => (
                  <option key={c.id} value={c.id}>{c.nombre}</option>
                ))}
            </TextField>
            {tipoPrograma !== "capacitacion" && (
              <TextField
                select
                fullWidth
                label="Modulo"
                value={form.semestre_id}
                sx={{ mt: 2 }}
                onChange={(e) => {
                  const val = e.target.value;

                  setSemestre(val);

                  setForm(prev => ({
                    ...prev,
                    semestre_id: val
                  }));
                }}
                SelectProps={{ native: true }}
              >
                <option value=""></option>
                {semestresDisponibles.map(s => (
                  <option key={s.id} value={s.id}>
                    {s.nombre} {s.numero}
                  </option>
                ))}
              </TextField>
            )}
          </>
        )}

        {/* ================== SECCIÓN 2: GRUPO ================== */}
        <Typography variant="subtitle1" fontWeight="bold" mt={3}>
          Grupo
        </Typography>

        <TextField
          select
          fullWidth
          name="gestion" 
          label="Gestión"
          value={form.gestion || ""}
          onChange={handleChange}                  
          SelectProps={{ native: true }}
        >
          <option value=""></option>
        
          {gestiones.map(g => (
            <option key={g.id} value={g.id}>
              {g.nombre}
            </option>
          ))}
        </TextField>
        <TextField
          fullWidth
          select
          label="Grupo"
          name="grupo_id"
          value={form.grupo_id}
          onChange={handleChange}
          SelectProps={{ native: true }}
          sx={{ mt: 2 }}
        >
          <option value=""></option>
          {grupos.map((g) => (
            <option key={g.id} value={g.id}>{g.nombre}</option>
          ))}
        </TextField>

        {/* ================== SECCIÓN 3: PAGOS ================== */}
        <Typography variant="h6" fontWeight="bold" mt={3} mb={2}>
          Datos de Pago
        </Typography>

        <Grid container spacing={2} alignItems="center">

          <Grid item xs={0} md={4} display={{ xs: "none", md: "block" }}>
            <strong>Concepto</strong>
          </Grid>
          <Grid item xs={0} md={4} display={{ xs: "none", md: "block" }}>
            <strong>Costo</strong>
          </Grid>
          <Grid item xs={0} md={4} display={{ xs: "none", md: "block" }}>
            <strong>Pago</strong>
          </Grid>

          {/* MATRÍCULA */}
          <Grid item xs={12} md={4}>
            <Typography>Matrícula</Typography>
          </Grid>

          <Grid item xs={12} md={4}>
            <TextField
              label="Costo"
              type="number"
              fullWidth
              name="matricula_costo"
              onWheel={(e) => e.target.blur()}
              value={form.matricula_costo ?? ""}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            {form.metodo_pago === "MIXTO" ? (
              <Box display="flex" gap={1}>
                <TextField
                  label="QR"
                  type="number"
                  fullWidth
                  onWheel={(e) => e.target.blur()}
                  value={form.matricula_pago_qr ?? ""}
                  onChange={(e) => {
                    const qr = Number(e.target.value) || 0;
                    const ef = Number(form.matricula_pago_efectivo) || 0;

                    setForm(prev => ({
                      ...prev,
                      matricula_pago_qr: qr,
                      matricula_pagado: qr + ef,
                    }));
                  }}
                />

                <TextField
                  label="Efectivo"
                  type="number"
                  fullWidth
                  onWheel={(e) => e.target.blur()}
                  value={form.matricula_pago_efectivo ?? ""}
                  onChange={(e) => {
                    const ef = Number(e.target.value) || 0;
                    const qr = Number(form.matricula_pago_qr) || 0;

                    setForm(prev => ({
                      ...prev,
                      matricula_pago_efectivo: ef,
                      matricula_pagado: qr + ef,
                    }));
                  }}
                />
              </Box>
            ) : (
              <TextField
                label="Pago"
                type="number"
                fullWidth
                onWheel={(e) => e.target.blur()}
                name="matricula_pagado"
                value={form.matricula_pagado ?? ""}
                onChange={handleChange}
              />
            )}
          </Grid>

          {/* MENSUALIDAD */}
          <Grid item xs={12} md={4}>
            <Typography>Mensualidad</Typography>
          </Grid>

          <Grid item xs={12} md={4}>
            <TextField
              label="Costo"
              type="number"
              fullWidth
              name="mensualidad_costo"
              onWheel={(e) => e.target.blur()}
              value={form.mensualidad_costo ?? ""}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            {form.metodo_pago === "MIXTO" ? (
              <Box display="flex" gap={1}>
                <TextField
                  label="QR"
                  type="number"
                  fullWidth
                  onWheel={(e) => e.target.blur()}
                  value={form.mensualidad_pago_qr ?? ""}
                  onChange={(e) => {
                    const qr = Number(e.target.value) || 0;
                    const ef = Number(form.mensualidad_pago_efectivo) || 0;

                    setForm(prev => ({
                      ...prev,
                      mensualidad_pago_qr: qr,
                      mensualidad_pagado: qr + ef,
                    }));
                  }}
                />

                <TextField
                  label="Efectivo"
                  type="number"
                  fullWidth
                  onWheel={(e) => e.target.blur()}
                  value={form.mensualidad_pago_efectivo ?? ""}
                  onChange={(e) => {
                    const ef = Number(e.target.value) || 0;
                    const qr = Number(form.mensualidad_pago_qr) || 0;

                    setForm(prev => ({
                      ...prev,
                      mensualidad_pago_efectivo: ef,
                      mensualidad_pagado: qr + ef,
                    }));
                  }}
                />
              </Box>
            ) : (
              <TextField
                label="Pago"
                type="number"
                fullWidth
                name="mensualidad_pagado"
                value={form.mensualidad_pagado ?? ""}
                onWheel={(e) => e.target.blur()}
                onChange={handleChange}
              />
            )}
          </Grid>

          {/* OTROS COBROS */}
          {selectedItems
            .filter(item => item.concepto !== 'matricula' && item.concepto !== 'mensualidad')
            .map((item, index) => (
              <React.Fragment key={item.id}>
                <Grid item xs={12} md={4}>
                  <Typography>{item.concepto}</Typography>
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField
                    label="Costo"
                    type="number"
                    fullWidth
                    value={item.monto ?? ""}
                    onWheel={(e) => e.target.blur()}
                    onChange={(e) => {
                      const newSelected = selectedItems.map((itm) =>
                        itm.id === item.id
                          ? { ...itm, monto: Number(e.target.value) }
                          : itm
                      );
                      setSelectedItems(newSelected);
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  {form.metodo_pago === "MIXTO" ? (
                    <Box display="flex" gap={1}>
                      <TextField
                        label="QR"
                        type="number"
                        fullWidth
                        onWheel={(e) => e.target.blur()}
                        value={item.otro_pago_qr ?? ""}
                        onChange={(e) => {
                          const qr = Number(e.target.value) || 0;

                          const nuevos = selectedItems.map((itm) =>
                            itm.id === item.id
                              ? {
                                  ...itm,
                                  otro_pago_qr: qr,
                                  pagado: qr + (itm.otro_pago_efectivo ?? 0),
                                }
                              : itm
                          );

                          setSelectedItems(nuevos);
                        }}
                      />

                      <TextField
                        label="Efectivo"
                        type="number"
                        fullWidth
                        onWheel={(e) => e.target.blur()}
                        value={item.otro_pago_efectivo ?? ""}
                        onChange={(e) => {
                          const ef = Number(e.target.value) || 0;

                          const nuevos = selectedItems.map((itm) =>
                            itm.id === item.id
                              ? {
                                  ...itm,
                                  otro_pago_efectivo: ef,
                                  pagado: (itm.otro_pago_qr ?? 0) + ef,
                                }
                              : itm
                          );

                          setSelectedItems(nuevos);
                        }}
                      />
                    </Box>
                  ) : (
                    <TextField
                      label="Pago"
                      type="number"
                      fullWidth
                      onWheel={(e) => e.target.blur()}
                      value={item.pagado ?? ""}
                      onChange={(e) => {
                        const nuevos = selectedItems.map((itm) =>
                          itm.id === item.id
                            ? {
                                ...itm,
                                pagado: Number(e.target.value),
                              }
                            : itm
                        );

                        setSelectedItems(nuevos);
                      }}
                    />
                  )}
                </Grid>
                {item.tipo_cobro === "mensual" && (
                  <>
                      <Grid item xs={12} md={8}>
                          <Typography variant="body2">
                              Número de cuotas para {item.concepto}
                          </Typography>
                      </Grid>

                      <Grid item xs={12} md={4}>
                          <TextField
                              type="number"
                              fullWidth
                              label="Cuotas"
                              value={item.numero_cuotas_otros_cobros ?? 1}
                              onChange={(e) => {
                                  const newSelected = selectedItems.map((itm) =>
                                      itm.id === item.id
                                          ? {
                                                ...itm,
                                                numero_cuotas_otros_cobros:
                                                    Number(e.target.value),
                                            }
                                          : itm
                                  );

                                  setSelectedItems(newSelected);
                              }}
                              inputProps={{
                                  min: 1,
                                  max: 24,
                              }}
                          />
                      </Grid>
                  </>
              )}

              </React.Fragment>    
          ))}
          
        </Grid>

        {/* CHECKLIST */}
        <Box mt={3}>
          <Typography variant="subtitle1" fontWeight="bold">Otros Cobros</Typography>
          {items.map((item) => (
            <FormControlLabel
              key={item.id}
              control={
                <Checkbox
                  checked={selectedItems.some(si => si.id === item.id)}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSelectedItems([
                        ...selectedItems,
                        {
                          ...item,
                          pagado: "",
                          monto: item.monto ?? "",
                          numero_cuotas_otros_cobros: item.tipo_cobro === 'mensual' ? "" : null
                        }
                      ]);
                    } else {
                      setSelectedItems(selectedItems.filter(si => si.id !== item.id));
                    }
                  }}
                />
              }
              label={item.concepto}
            />
            
          ))}
        </Box>

        {/* MÉTODO DE PAGO */}
        <Box mt={3}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <TextField
                select
                fullWidth
                label="Método de pago"
                name="metodo_pago"
                value={form.metodo_pago || ""}
                onChange={(e) => {
                  const metodo = e.target.value;

                  // Solo limpiar si entra o sale de MIXTO
                  const debeLimpiar =
                    metodo === "MIXTO" ||
                    form.metodo_pago === "MIXTO";

                  if (debeLimpiar) {
                    // Limpiar otros cobros
                    const nuevosItems = selectedItems.map(item => ({
                      ...item,
                      pagado: "",
                      otro_pago_qr: "",
                      otro_pago_efectivo: "",
                    }));

                    setSelectedItems(nuevosItems);
                  }

                  setForm(prev => ({
                    ...prev,
                    metodo_pago: metodo,

                    ...(debeLimpiar && {
                      // Matrícula
                      matricula_pagado: "",
                      matricula_pago_qr: "",
                      matricula_pago_efectivo: "",

                      // Mensualidad
                      mensualidad_pagado: "",
                      mensualidad_pago_qr: "",
                      mensualidad_pago_efectivo: "",
                    }),
                  }));
                }}
                SelectProps={{ native: true }}
              >
                <option value=""></option>
                <option value="QR">QR</option>
                <option value="EFECTIVO">EFECTIVO</option>
                <option value="MIXTO">MIXTO</option>
              </TextField>
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                type="number"
                fullWidth
                label="Número de cuotas para la mensualidad"
                name="numero_cuotas"
                value={form.numero_cuotas || ""}
                onChange={(e) =>
                  setForm(prev => ({
                    ...prev,
                    numero_cuotas: e.target.value,
                  }))
                }
              />
            </Grid>
          </Grid>
        </Box>

        <Box mt={3}>
          <Typography variant="h6">
            Total pagado: Bs. {calcularTotalPagado().toFixed(2)}
          </Typography>
          <Typography variant="h6" color="error.main">
            Deuda acumulada: Bs. {calcularDeuda().toFixed(2)}
        </Typography>
        </Box>

        {/* BOTONES */}
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
          <MDButton color="secondary" onClick={handleClose} sx={{ mr: 1 }}>
            Cancelar
          </MDButton>

          <MDButton color="primary" onClick={handleSubmit} disabled={loading}>
            Inscribir
          </MDButton>
        </Box>

      </Box>
    </Modal>
  );
}
